import Schema from 'validate';
import { isPostalCode } from 'validator';
import isEmail from 'validator/lib/isEmail';

import { get } from 'lodash';
import OrgaSchema from '../../../../lib/paths/organisation_FULL_Paths.json';
const P = OrgaSchema.attributes;

const mailValidator = (val: string) => isEmail(val);
const postalCodeValidator = (val: string) => isPostalCode(val, 'DE');

const OrganisationDatenValidator = (orgaDaten: any) => {
	const steuernummer = get(orgaDaten, P.Unternehmensprofil_Steuernummer.path);
	const ustid = get(orgaDaten, P.Unternehmensprofil_U_St_Id_Nr.path);
	const hasSteuerOrUmsatzNummer =
		(typeof steuernummer === 'string' ? steuernummer.trim() !== '' : !!steuernummer) || (typeof ustid === 'string' ? ustid.trim() !== '' : !!ustid);
	const HAS_STEUER_OR_UMSATZ_NUMMER_MESSAGE = 'Bitte geben Sie entweder eine Steuernummer oder eine USt-IdNr. an.';

	const newSchema = new Schema({
		[P.Unternehmensprofil_U_St_Id_Nr.path]: {
			type: String,
			required: !hasSteuerOrUmsatzNummer,
			message: {
				required: HAS_STEUER_OR_UMSATZ_NUMMER_MESSAGE,
			},
		},
		[P.Unternehmensprofil_Steuernummer.path]: {
			type: String,
			required: !hasSteuerOrUmsatzNummer,
			message: {
				required: HAS_STEUER_OR_UMSATZ_NUMMER_MESSAGE,
			},
		},
		[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
			type: String,
			required: true,
		},
		[P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_PLZ.path]: {
			type: String,
			required: true,
			use: { postalCodeValidator },
			message: {
				postalCodeValidator: 'Ungültige Postleitzahl.',
			},
		},
		[P.Adressdaten_Ort.path]: {
			type: String,
			required: true,
		},
		[P.Geschaeftsbezogene_Daten_Kuerzel.path]: {
			type: String,
		},
		[P.Geschaeftsbezogene_Daten_Zustimmung_Erhalt_Newsletter.path]: {
			type: Boolean,
		},
		[P.Kontaktdaten_E_Mail.path]: {
			type: String,
			required: true,
			use: { mailValidator },
			message: {
				mailValidator: 'Ungültige E-Mail-Adresse.',
			},
		},
		[P.Kontaktdaten_Telefon.path]: {
			type: String,
			required: true,
			use: {
				phone: (val: string) => /^[0-9\s]*$/.test(val),
			},
			message: {
				phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
			},
		},
	});

	newSchema.message({
		required: (_path: string) => 'Dies ist ein Pflichtfeld',
		type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Felder. Geben Sie als Grund "falscher Datantyp, ${path}" an`,
	});

	return newSchema;
};

export default OrganisationDatenValidator;
